/**
 * Музыкальные данные тренажёров. Держим их здесь, а не в Mini App:
 * бот подсказывает названия аккордов в тексте занятия из того же списка,
 * и расходиться этим двум местам нельзя.
 */
/** Частоты открытых струн, стандартный строй. Индекс 0 — 6-я (самая толстая). */
export const OPEN_STRINGS = [82.41, 110.0, 146.83, 196.0, 246.94, 329.63];
export const STRING_NAMES = [
    { label: '6-я — ми', note: 'E' },
    { label: '5-я — ля', note: 'A' },
    { label: '4-я — ре', note: 'D' },
    { label: '3-я — соль', note: 'G' },
    { label: '2-я — си', note: 'B' },
    { label: '1-я — ми', note: 'e' },
];
export const CHORDS = {
    Em: { frets: [0, 2, 2, 0, 0, 0], fingers: [0, 2, 3, 0, 0, 0], week: 2 },
    Am: { frets: [-1, 0, 2, 2, 1, 0], fingers: [0, 0, 2, 3, 1, 0], week: 2 },
    Dm: { frets: [-1, -1, 0, 2, 3, 1], fingers: [0, 0, 0, 2, 3, 1], week: 2 },
    C: { frets: [-1, 3, 2, 0, 1, 0], fingers: [0, 3, 2, 0, 1, 0], week: 3 },
    G: { frets: [3, 2, 0, 0, 0, 3], fingers: [2, 1, 0, 0, 0, 3], week: 3 },
    D: { frets: [-1, -1, 0, 2, 3, 2], fingers: [0, 0, 0, 1, 3, 2], week: 3 },
    Dsus2: { frets: [-1, -1, 0, 2, 3, 0], fingers: [0, 0, 0, 1, 3, 0], week: 3 },
    E7: { frets: [0, 2, 0, 1, 0, 0], fingers: [0, 2, 0, 1, 0, 0], week: 4 },
};
export const CHORD_NAMES = Object.keys(CHORDS);
export const TABS = {
    ode: {
        name: 'Ода к радости',
        courseKey: 'ode_to_joy',
        bpm: 80,
        notes: [
            [5, 0], [5, 0], [5, 1], [5, 3], [5, 3], [5, 1], [5, 0], [4, 3],
            [4, 1], [4, 1], [4, 3], [5, 0], [5, 0], [4, 3], [4, 3],
        ],
    },
    spider: {
        name: 'Паучок',
        courseKey: 'spider',
        bpm: 66,
        notes: [
            [0, 1], [0, 2], [0, 3], [0, 4], [1, 1], [1, 2], [1, 3], [1, 4],
            [4, 1], [4, 2], [4, 3], [4, 4], [5, 1], [5, 2], [5, 3], [5, 4],
        ],
    },
    riff: {
        name: 'Рок-рифф',
        courseKey: 'first_riff',
        bpm: 75,
        notes: [
            [0, 0], [0, 0], [0, 3], [0, 0], [0, 0], [0, 0], [0, 5], [0, 3],
            [0, 0], [0, 0], [0, 3], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0],
        ],
    },
    melody: {
        name: 'Мелодия по струне',
        courseKey: 'melody_line',
        bpm: 70,
        notes: [[5, 0], [5, 1], [5, 3], [5, 5], [5, 3], [5, 1], [5, 0]],
    },
};
export const PATTERNS = {
    down: { name: 'Вниз ↓↓↓↓', slots: ['D', '', 'D', '', 'D', '', 'D', ''], courseKey: 'downs' },
    eight: { name: 'Восьмёрка ↓↑↓↑', slots: ['D', 'U', 'D', 'U', 'D', 'U', 'D', 'U'], courseKey: 'eight' },
    universal: { name: 'Универсальный', slots: ['D', '', 'D', 'U', '', 'U', 'D', 'U'], courseKey: 'universal' },
};
/** Счёт под бой: «раз-и-два-и-три-и-четыре-и». */
export const COUNT = ['1', 'и', '2', 'и', '3', 'и', '4', 'и'];
/** Частота ноты на струне и ладу. Полутон — корень двенадцатой степени из двух. */
export function noteFreq(stringIndex, fret) {
    const open = OPEN_STRINGS[stringIndex];
    if (open === undefined)
        throw new Error(`Нет струны с номером ${stringIndex}`);
    return open * Math.pow(2, fret / 12);
}
export const DAY_TOOLS = {
    1: [{ kind: 'tuner', id: 'tuner', label: 'Послушать струны' }],
    2: [{ kind: 'tuner', id: 'tuner', label: 'Послушать струны' }],
    3: [{ kind: 'tab', id: 'spider', label: 'Паучок' }],
    4: [{ kind: 'tab', id: 'ode', label: 'Ода к радости' }],
    5: [{ kind: 'tab', id: 'ode', label: 'Ода к радости' }],
    8: [{ kind: 'chord', id: 'Em', label: 'Аккорд Em' }],
    9: [{ kind: 'chord', id: 'Am', label: 'Аккорд Am' }],
    10: [{ kind: 'strum', id: 'down', label: 'Бой «вниз»' }],
    11: [{ kind: 'chord', id: 'Dm', label: 'Аккорд Dm' }],
    12: [{ kind: 'strum', id: 'down', label: 'Бой и смены' }],
    15: [{ kind: 'chord', id: 'C', label: 'Аккорд C' }],
    16: [{ kind: 'chord', id: 'G', label: 'Аккорд G' }],
    17: [{ kind: 'chord', id: 'D', label: 'Аккорд D' }],
    18: [{ kind: 'strum', id: 'eight', label: 'Бой «восьмёрка»' }],
    19: [{ kind: 'strum', id: 'eight', label: 'Играть песню' }],
    22: [{ kind: 'chord', id: 'Am', label: 'Смены аккордов' }],
    23: [{ kind: 'tab', id: 'riff', label: 'Рок-рифф' }],
    24: [{ kind: 'tab', id: 'melody', label: 'Мелодия' }],
    25: [{ kind: 'strum', id: 'eight', label: 'Играть в темп' }],
    26: [{ kind: 'tab', id: 'ode', label: 'Программа' }],
    29: [{ kind: 'strum', id: 'eight', label: 'Концерт' }],
};
//# sourceMappingURL=music.js.map